import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';

const intrestCSV = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-Audience-Intrest.csv';
const demographicCSV = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-Demographic.csv';
const purchaseIntentCSV = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/data-Purchase-Intent.csv';

const AudienceIntrest = () => {
  const [intrestData, setIntrestData] = useState([]);
  const [demographicData, setDemographicData] = useState([]);
  const [purchaseIntentData, setPurchaseIntentData] = useState([]);
  const [activeTab, setActiveTab] = useState('content');
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    fetch(intrestCSV)
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          transformHeader: header => header.trim(),
          complete: (results) => setIntrestData(results.data),
        });
      });
  }, []);

  useEffect(() => {
    fetch(demographicCSV)
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          transformHeader: header => header.trim(),
          complete: (results) => setDemographicData(results.data),
        });
      });
  }, []);

  useEffect(() => {
    fetch(purchaseIntentCSV)
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          transformHeader: header => header.trim(),
          complete: (results) => setPurchaseIntentData(results.data),
        });
      });
  }, []);

  const toggleExpand = (key) => {
    setExpanded(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const parseNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const buildTree = (data, tiers) => {
    const tree = {};

    data.forEach(row => {
      let currentLevel = tree;
      let node = null;

      tiers.forEach(tier => {
        const label = row[tier];
        if (!label) return;

        if (!currentLevel[label]) {
          currentLevel[label] = {
            selfMetrics: { uniques: 0, pageviews: 0 },
            metrics: { uniques: 0, pageviews: 0 },
            children: {}
          };
        }

        node = currentLevel[label];
        currentLevel = node.children;
      });

      if (node) {
        node.selfMetrics.uniques += parseNumber(row['Uniques User Million']);
        node.selfMetrics.pageviews += parseNumber(row['Pageviews in Million']);
      }
    });

    const aggregateMetrics = (node) => {
      let totalUniques = 0;
      let totalPageviews = 0;

      Object.values(node.children).forEach(child => {
        const childTotals = aggregateMetrics(child);
        totalUniques += childTotals.uniques;
        totalPageviews += childTotals.pageviews;
      });

      totalUniques += node.selfMetrics.uniques;
      totalPageviews += node.selfMetrics.pageviews;

      node.metrics.uniques = totalUniques;
      node.metrics.pageviews = totalPageviews;

      return node.metrics;
    };

    Object.values(tree).forEach(aggregateMetrics);

    return tree;
  };

  const renderRows = (node, level = 0, parentKey = '') => {
    return Object.entries(node).map(([label, data]) => {
      const key = `${parentKey}-${label}`;
      const isExpanded = expanded[key];
      const paddingLeft = `${level * 20}px`;

      return (
        <React.Fragment key={key}>
          <tr className="cursor-pointer hover:bg-gray-50" onClick={() => toggleExpand(key)}>
            <td className="border-b px-4 py-2 font-medium text-gray-700" style={{ paddingLeft }}>
              {Object.keys(data.children).length > 0 && (
                <span className="mr-1">{isExpanded ? '▾' : '▸'}</span>
              )}
              {label}
            </td>
            <td className="border-b px-4 py-2">{Math.round(data.metrics.uniques)}</td>
            <td className="border-b px-4 py-2">{Math.round(data.metrics.pageviews)}</td>
          </tr>
          {isExpanded && renderRows(data.children, level + 1, key)}
        </React.Fragment>
      );
    });
  };

  const renderTable = (data, tiers) => {
    const treeData = buildTree(data, tiers);
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border">
          <thead>
            <tr className="bg-gray-50 text-left text-sm font-semibold text-gray-600">
              <th className="px-4 py-2 border-b">Audience</th>
              <th className="px-4 py-2 border-b">Uniques User (Million)</th>
              <th className="px-4 py-2 border-b">Pageviews (Million)</th>
            </tr>
          </thead>
          <tbody>{renderRows(treeData)}</tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Manage Audience</h2>

      <div className="flex border-b mb-4">
        <button
          className={`px-6 py-2 border-b-2 font-medium ${activeTab === 'content' ? 'border-black text-black' : 'border-transparent text-gray-500'}`}
          onClick={() => setActiveTab('content')}
        >
          Audience Interest
        </button>
        <button
          className={`px-6 py-2 border-b-2 font-medium ${activeTab === 'demographic' ? 'border-black text-black' : 'border-transparent text-gray-500'}`}
          onClick={() => setActiveTab('demographic')}
        >
          Demographic
        </button>
        <button
          className={`px-6 py-2 border-b-2 font-medium ${activeTab === 'purchaseIntent' ? 'border-black text-black' : 'border-transparent text-gray-500'}`}
          onClick={() => setActiveTab('purchaseIntent')}
        >
          Purchase Intent
        </button>
      </div>

      {activeTab === 'content' &&
        renderTable(intrestData, ['Intrest', 'Intrest Tier 1', 'Intrest Tier 2', 'Intrest Tier 3', 'Intrest Tier 4'])
      }

      {activeTab === 'demographic' &&
        renderTable(demographicData, ['Tier 1', 'Tier 2', 'Tier 3'])
      }

      {activeTab === 'purchaseIntent' &&
        renderTable(purchaseIntentData, ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4'])
      }
    </div>
  );
};

export default AudienceIntrest;
